module.exports = __webpack_public_path__ + "static/media/skip.286746ac.svg";